/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S2_P1Inputs */

const en_guide_json_syntax_errors_s2_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON requires double quotes for all strings and keys. Single quotes, backticks, or unquoted keys are not valid.`)
};

const ko_guide_json_syntax_errors_s2_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON에서는 모든 문자열과 키에 큰따옴표를 사용해야 합니다. 작은따옴표, 백틱, 또는 따옴표 없는 키는 유효하지 않습니다.`)
};

const ja_guide_json_syntax_errors_s2_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONではすべての文字列とキーにダブルクォートが必要です。シングルクォート、バッククォート、クォートなしのキーは無効です。`)
};

/**
* | output |
* | --- |
* | "JSON requires double quotes for all strings and keys. Single quotes, backticks, or unquoted keys are not valid." |
*
* @param {Guide_Json_Syntax_Errors_S2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s2_p1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s2_p1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s2_p1(inputs)
	return ja_guide_json_syntax_errors_s2_p1(inputs)
});